import React from 'react'
import { Stack, Typography } from '@mui/material'
import { numberFormat } from '@/helpers/numbers'

type Props = {
  optionsItemList: { id: string | number; price: string; name: string }[]
}

const OptionsItemList: React.FC<Props> = (props) => {
  const { optionsItemList } = props
  const hasOptions = optionsItemList != null && optionsItemList.length > 0

  return hasOptions ? (
    <Stack paddingX={1} paddingY={1} spacing={1}>
      {optionsItemList.map((item) => {
        const price = parseFloat(item.price || '')
        return (
          <Stack key={item.id} direction="row" justifyContent="space-between" spacing={1}>
            <Typography variant="body1">
              {price > 0 ? 'Upgrade: ' : 'Option: '}
              {item.name.slice(0, 30)}
            </Typography>
            {price > 0 ? <Typography variant="body1">{numberFormat(price)}</Typography> : null}
          </Stack>
        )
      })}
    </Stack>
  ) : null
}

export default OptionsItemList
